import pallette from './pallette';

type HelpTheme = {
    colors: {
        tooltip: {
            text: string;
            background: string;
            inverted: {
                text: string;
                background: string;
            };
        };
        tooltipToggle: {
            text: string;
            background: string;
            border: string;
        };
    };
};

const { transparent, white, black, midGreen } = pallette;

const help: HelpTheme = {
    colors: {
        tooltip: {
            text: black,
            background: 'rgba(255,255,255,0.9)',
            inverted: {
                text: white,
                background: 'rgba(0,0,0,0.9)',
            },
        },
        tooltipToggle: {
            text: white,
            background: transparent,
            border: midGreen,
        },
    },
};

export default help;
